<template>
    <div class="w-100 date-breached-empty-screen">
        <v-app-bar app elevation="0" color="surface" class="justify-start py-3">
            <v-list-item class="d-flex justify-space-between webapp-main-topbar">
                <div class="flex-grow-1">
                    <div class="logo-container">
                        <LogoComponent />
                    </div>
                </div>
            </v-list-item>
        </v-app-bar>
        
        <template v-if="isAuthenticated">
            <div class="d-flex flex-column align-center" style="height: calc(100vh - 128px);">
                <header>
                    <h6>VIBGYOR Organizational Leadership Training (VOLT) Assessment</h6>
                </header>
                <div>
                    <v-img src="../assets/vgos_internal.svg" alt="VGOS Internal User" width="550"></v-img>
                </div>
                <div class="text-container mt-4 text-center">
                    <p v-if="errorMessage" class="font-weight-bold text-center text-h6">{{ errorMessage }}</p>
                    <v-btn 
                        v-else 
                        color="elevation-0 btn primary-btn rounded-full" 
                        @click="startNow" 
                        :loading="isLoadingCampaign"
                        :disabled="isLoadingCampaign"
                    >
                        Start Assessment
                    </v-btn>
                </div>
            </div>
        </template>
        
        <template v-else>
            <template v-if="!errorMessage">
                <BubbleLoader v-if="isLoading"/>
            </template>
            <template v-else>
                <div class="d-flex flex-column align-center" style="height: calc(100vh - 128px);">
                    <header>
                        <h6>{{ errorMessage }}</h6>
                    </header>
                    <div>
                        <v-img src="../assets/user_not_found.svg" alt="User Not Found" width="550"></v-img>
                    </div>
                    <div class="text-container mt-4 text-center">
                        <v-btn color="elevation-0 btn primary-btn rounded-full" @click="logoutTeacher">
                            <v-icon left>mdi-keyboard-backspace</v-icon>
                            Back
                        </v-btn>
                    </div>
                </div>  
            </template>
        </template>

        <!-- Mobile/Tablet view -->
        <template v-if="screenWidth <= 1024 && isAuthenticated">
            <div class="w-100 date-breached-empty-screen">
                <v-app-bar app elevation="0" color="surface" class="justify-start py-3">
                    <v-list-item class="d-flex justify-space-between webapp-main-topbar">
                        <div class="flex-grow-1">
                            <div class="logo-container">
                                <LogoComponent />
                            </div>
                        </div>
                        <v-list-item-action class="mx-0 my-0">
                            <div class="d-flex align-center user-profile-container">
                                <p role-type="subtitle-3" class="px-0 py-0 mb-0 webapp-text">Hello,</p>
                                <p role-type="subtitle-3" class="px-0 py-0 mb-0 ml-1 webapp-username" v-if="userInfo?.personalInfo != null">
                                    {{ userInfo?.personalInfo.firstName | capitalizeFirst }} 👋
                                </p>
                                <UserNavMenu></UserNavMenu>
                            </div>
                        </v-list-item-action>
                    </v-list-item>
                </v-app-bar>

                <div class="d-flex justify-center flex-column align-center pa-4" style="height: calc(100vh - 80px);">
                    <div>
                        <img src="../assets/Submit.svg" alt="Date is breached" />
                    </div>
                    <div class="text-container mt-12 text-center">
                        <p>
                            Thank you for expressing your interest. We have successfully recorded your preferences. 
                            An email with a link to the assessment has been sent to you. Kindly complete the 
                            assessment on a laptop or desktop equipped with a webcam.
                        </p>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import keycloakAuthMixin from '../mixins/keycloakAuthMixin';
import keycloakService from "../services/KeycloakService";
import AuthService from "../services/AuthService";
import UserNavMenu from "../components/UserNavMenu.vue";
import LogoComponent from '@/components/LogoComponent.vue';
import BubbleLoader from '../components/BubbleLoader.vue';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import UserController from '../controllers/UserController';
export default {
    name: 'InternalUserLanding',
    components: {
        UserNavMenu,
        LogoComponent,
        BubbleLoader
    },
    mixins: [keycloakAuthMixin],
    data() {
        return {
            screenWidth: window.innerWidth,
            isLoadingCampaign: false,
            campaignIdReady: false
        }
    },
    async created() {
        window.addEventListener('resize', this.updateScreenWidth);
        await this.initializeAuth();
    },
    async mounted() {
        // Handle case where user is already authenticated on page load
        if (this.isAuthenticated) {
            await this.setLatestCampaignId();
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateScreenWidth);
    },
    methods: {
        updateScreenWidth() {
            this.screenWidth = window.innerWidth;
        },
        
        logoutTeacher() {
            keycloakService.doLogout();
        },
        
        async startNow() {
            // Ensure campaign ID is loaded before proceeding
            if (!this.campaignIdReady) {
                await this.getUserInfo();
                await this.setLatestCampaignId();
            }
            
            const campaignId = this.$store.getters.userInfo?.campaignId;
            if (!campaignId) {
                this.errorMessage = "Unable to load campaign information. Please try again.";
                return;
            }
            
            this.$router.push("/assesment-instruction");
        },
        
        async setLatestCampaignId() {
            let campaignId = this.$store.getters.userInfo?.campaignId;
            const userId = AuthService.getUserId();
            
            if (campaignId) {
                this.campaignIdReady = true;
                return;
            }
            
            if (!userId) {
                console.error('No user ID available');
                this.errorMessage = "User information not available.";
                return;
            }

            this.isLoadingCampaign = true;
            
            try {
                const campaignUserRef = collection(db, "users", userId, "campaigns");
                const latestCampaignQuery = query(
                    campaignUserRef,
                    orderBy("createdOn", "desc"),
                    limit(1)
                );
                
                const latestCampaignSnapshot = await getDocs(latestCampaignQuery);
                
                if (!latestCampaignSnapshot.empty) {
                    const latestCampaignDoc = latestCampaignSnapshot.docs[0];
                    campaignId = latestCampaignDoc.id;
                    
                    // Cache for later access
                    await this.$store.dispatch("setCampaignId", campaignId);
                    this.campaignIdReady = true;
                    console.log('Campaign ID set:', campaignId);
                } else {
                    console.warn('No campaigns found for user');
                    this.errorMessage = "No active campaigns found. Please contact support.";
                }
            } catch (error) {
                console.error('Error fetching campaign ID:', error);
                this.errorMessage = "Failed to load campaign information.";
            } finally {
                this.isLoadingCampaign = false;
            }
        },
        async getUserInfo() {
            const response = await UserController.getUserInfo();
            this.$store.dispatch('setUserInfo', response.data.data)
        },
    },
    watch: {
        // Trigger campaign ID fetch when authentication state changes
        async isAuthenticated(newValue, oldValue) {
            if (newValue && !oldValue) {
                await this.getUserInfo();
                await this.setLatestCampaignId();
            }
        }
    },
    computed: {
        userInfo() {
            return this.$store.getters.userInfo;
        }
    }
}
</script>

<style scoped>
/* Add your styles here */
</style>